// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"3b50dd47","102":"5a316d6c","105":"366b77a8","241":"a03bc966","275":"a0dc93cd","333":"2187e8f8","389":"76cbd909","520":"5392a72c","526":"57fb9311","549":"93e58773","764":"0f349dc7","796":"236257d3","845":"754f1f28","912":"a3c0fd01"}[chunkId] + ".chunk.js";
};